<template>
    <div>
        <username-selection-component />

        <hr>

        <div class="row">
            <div class="col-md-6">
                <button class="btn btn-primary" @click="save">Next</button>
            </div>

            <div class="col-md-6 align-self-end">
                <div class="text-right">
                    <button class="btn btn-secondary btn-sm skip" @click="skip">Skip</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        },

        data() {
            return {
                
            }
        },

        mounted() {
        },

        methods: {
            // Skip
            skip() {
                Bus.$emit('stepComplete', {
                    'step': 'username',
                    'skip': true,
                    'percentageComplete': 80,
                });
            },

            // Save
            save() {
                Bus.$emit('stepComplete', {
                    'step': 'username',
                    'skip': false,
                    'percentageComplete': 80,
                });
            },
        }
    }
</script>